import React, { PureComponent } from 'react';
import { graphql, compose, withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import SignDocument from '../SignDocument';
import T from 'i18n-react';
import PropTypes from 'prop-types';
import Message from '../../Message';
import _ from 'lodash';
import { TIMEOUT_TRESHOLD } from '../../../constants';
import Cache from '../../../utils/cache';

class SignDocumentContainer extends PureComponent {
  state = {
    signed: false,
    error: '',
  };
  cache = new Cache()

  handleError = () => {
    const { history, client, match } = this.props;
    const token = match.params.id;
    return this.redirectTimeout = setTimeout(() => {
      client.resetStore()
        .then(() => history.push(`/loa-lawyer/${token}/preview`))
        .catch(() => history.push(`/loa-lawyer/${token}/preview`))
    }, TIMEOUT_TRESHOLD);
  };

  signDocument = () => {
    const { onSignedDocument, data = {}} = this.props;
    const { match } = this.props;
    const token = match.params.id;    
    const loaLawyerId = data.loaLawyer && data.loaLawyer.id;
    onSignedDocument(loaLawyerId)
      .then(() => this.setState({ signed: true }))
      .catch(error => {
        const errorMessage = _.get(error, 'networkError.result.message', '');
        if (errorMessage === 'LoaLawyers::Service::LawFirmChanged') {
          this.setState({ error: 'LawFirmChanged' });
          return this.handleError();
        }
        if (errorMessage === 'LoaLawyers::Service::LoaLawyerChanged') {
          this.setState({ error: 'LoaLawyerChanged' });
          return this.handleError();
        }
        this.setState({ error: 'serverError' });
      })
      .finally( () => this.cache.clearToken(token));
  };

  componentWillUnmount = () => {
    clearTimeout(this.redirectTimeout);
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { data } = this.props;
    const { data: prevData } = prevProps;
    const docUrl = _.get(data, 'loaLawyer.documentUrl')
    const prevDocUrl = _.get(prevData, 'loaLawyer.documentUrl')

    if (!prevDocUrl && docUrl) {
      return data.stopPolling();
    }
  };

  render() {
    const { data, progressBar, paxDisplayName } = this.props;
    const { error } = this.state;
    const documentUrl = _.get(data, 'loaLawyer.documentUrl')

    const isLoading = !documentUrl;

    if (this.state.signed) {
      return Message(T.translate('docSigned'), true);
    }

    if (error) {
      return Message(T.translate(error), null, true);
    }

    return (
      <SignDocument
        documentUrl={documentUrl}
        onSubmit={this.signDocument}
        progressBar={progressBar}
        paxDisplayName={paxDisplayName}
        isLoading={isLoading}
      />
    );
  }
}

const generatedDocument = gql`
  query loaLawyer($token: String!) {
    loaLawyer(token: $token) {
      id
      documentUrl
    }
  }
`;

const SignDocumentMutation = gql`
  mutation SignDocument($input: SignLoaLawyerMutationInput!) {
    signLoaLawyer(input: $input) {
      loaLawyer {
        id
      }
    }
  }
`;

const LoaLawyerDocumentData = gql`
  query LoaLawyerDocumentData($token: String!) {
    loaLawyerDocumentData(token: $token) {
      lawFirm {
        id
        name
        city
        country
        street
      }
      airline {
        name
      }
    }
  }
`;

export default compose(
  withApollo,
  graphql(generatedDocument, {
    options: props => {
      const token = props.match.params.id;
      return {
        pollInterval: 10000,
        variables: { token },
      };
    },
  }),
  graphql(SignDocumentMutation, {
    props: ({
      mutate,
      ownProps: {
        match: {
          params: { id },
        },
      },
    }) => ({
      onSignedDocument: loaLawyerId =>
        mutate({ variables: { input: { token: id, id: loaLawyerId } } }),
    }),
  }),
  graphql(LoaLawyerDocumentData, {
    name: 'LoaLawyerData',
    options: props => {
      const token = props.match.params.id;
      return {
        variables: { token },
      };
    },
  }),
)(SignDocumentContainer);

SignDocumentContainer.propTypes = {
  data: PropTypes.object.isRequired,
  onSignedDocument: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  progressBar: PropTypes.element.isRequired,
  paxDisplayName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/LoaLawyer/containers/SignDocumentContainer.js